<template>
    <div class="screen">
        <div class="screen__inner">
            <div class="screen__line">
                <img
                    :src="quizBlueLine"
                    alt=""
                />
            </div>
            <h3 class="screen__header heading-tertiary">{{ question }}</h3>
            <div class="screen__counter">
                <p class="screen__text heading-tertiary">
                    <span class="current-page">{{ currentPage }}</span>
                    &nbsp;<span class="total-pages"> /{{ totalPages }}</span>
                </p>
            </div>
        </div>
        <form
            class="screen__form"
            @submit.prevent="handleSubmit"
        >
            <label
                v-for="(answer, index) in answers"
                :key="index"
                class="screen__label"
            >
                <input
                    v-model="selectedAnswer"
                    class="screen__radio"
                    type="radio"
                    :value="answer"
                />
                <p class="screen__answer paragraph-primary">{{ $t(answer) }}</p>
            </label>
            <div class="screen__buttons">
                <button
                    v-if="showBackButton"
                    class="screen__button btn btn-secondary"
                    type="button"
                    @click="handleBack"
                >
                    {{ $t('__quiz_button_back') }}
                </button>
                <button
                    class="screen__button btn btn-primary btn--new"
                    type="submit"
                    :style="buttonStyle"
                >
                    {{ $t('__quiz_button_next') }}
                </button>
            </div>
        </form>
        <div class="screen__background">
            <img
                :src="questionIcon"
                alt=""
            />
        </div>
    </div>
</template>

<script>
import quizBlueLine from '../../assets/svg/quiz/quiz-blue-line.svg';
import questionIcon from '../../assets/svg/quiz/question.svg';

import { QUIZ_STATE_KEY } from './Quiz.vue';

export default {
    props: {
        question: {
            type: String,
            required: true,
        },
        answers: {
            type: Array,
            required: true,
        },
        initialAnswer: {
            type: String,
            default: '',
        },
        showBackButton: {
            type: Boolean,
            default: false,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedAnswer: this.initialAnswer,
            quizBlueLine,
            questionIcon,
        };
    },
    computed: {
        buttonStyle() {
            return {
                width: this.showBackButton ? '104px' : '224px',
            };
        },
    },
    watch: {
        selectedAnswer(newAnswer) {
            this.$emit('updateInLocalStorage', newAnswer);
        },
        answers(newAnswers) {
            const [firstAnswer] = newAnswers;
            const savedState = JSON.parse(localStorage.getItem(QUIZ_STATE_KEY));
            if (savedState) {
                const savedAnswer = savedState.userAnswers[this.currentPage - 1];
                this.selectedAnswer = savedAnswer || firstAnswer;
            }
        },
    },
    created() {
        let savedAnswer = null;
        const savedState = JSON.parse(localStorage.getItem(QUIZ_STATE_KEY));
        if (savedState) {
            savedAnswer = savedState.userAnswers[this.currentPage - 1];
        }
        if (savedAnswer) {
            this.selectedAnswer = savedAnswer;
        } else {
            const [firstAnswer] = this.answers;
            this.selectedAnswer = firstAnswer;
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('next', this.selectedAnswer);
        },
        handleBack() {
            this.$emit('back');
        },
    },
};
</script>
